import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ChildrenContext = createContext(null);

export function ChildrenProvider({ children }) {
  const { user } = useAuth();
  const [kids, setKids] = useState([]);
  const [activeChildId, setActiveChildId] = useState(null);

  const load = useCallback(async () => {
    if (!user) {
      setKids([]);
      setActiveChildId(null);
      return;
    }
    const { data } = await api.get("/children");
    setKids(data);
    if (data.length && !activeChildId) setActiveChildId(data[0].id);
  }, [user, activeChildId]);

  useEffect(() => {
    load();
  }, [load]);

  const addChild = async (payload) => {
    const { data } = await api.post("/children", payload);
    setKids((k) => [...k, data]);
    if (!activeChildId) setActiveChildId(data.id);
    return data;
  };

  const removeChild = async (id) => {
    await api.delete(`/children/${id}`);
    setKids((k) => k.filter((c) => c.id !== id));
    if (activeChildId === id) setActiveChildId(null);
  };

  const activeChild = kids.find((c) => c.id === activeChildId) || null;

  return (
    <ChildrenContext.Provider
      value={{ kids, activeChild, activeChildId, setActiveChildId, addChild, removeChild, reload: load }}
    >
      {children}
    </ChildrenContext.Provider>
  );
}

export const useChildren = () => useContext(ChildrenContext);
